import { useEffect, useState } from 'react';

export const PORTAL_CONFIG_UPDATED_EVENT = 'omega-rtc:portal-config-updated';

export type HolosPortalFeatureFlag =
  | 'disableContentConfigEdits'
  | 'enabledContentConfigAudiences'
  | 'enabledContentConfigAudienceTableSource'
  | 'enabledProductOfferingAudiences';

export const isHolosPortalFeatureEnabled = (
  feature: HolosPortalFeatureFlag,
): boolean => window.Grab.config.PORTAL_CONFIG?.holos?.[feature] === true;

export const useHolosPortalFeatureFlag = (
  feature: HolosPortalFeatureFlag,
): boolean => {
  const [enabled, setEnabled] = useState(
    () => isHolosPortalFeatureEnabled(feature),
  );

  useEffect(() => {
    const updateFlag = () => setEnabled(isHolosPortalFeatureEnabled(feature));
    updateFlag();
    window.addEventListener(PORTAL_CONFIG_UPDATED_EVENT, updateFlag);
    return () => window.removeEventListener(PORTAL_CONFIG_UPDATED_EVENT, updateFlag);
  }, [feature]);

  return enabled;
};
